import React from 'react';


const AboutPage = () => {


  return (

    <div className="bg-creamColor min-h-screen flex items-center justify-center">
      <div className="max-w-5xl mx-auto p-6">
        {/* Header Section */}
        <div className="text-center mb-10">

          <h1 className="text-4xl font-serif italic text-gray-800 poppins-medium">
            Welcome to Booklore Blogs
          </h1>


          <p className="text-sm text-gray-600 uppercase tracking-wider mt-2 poppins-medium">
            Building Communities, One Story at a Time!
          </p>

        </div>

        {/* Images Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          <div className="overflow-hidden rounded-lg">
            
              <img
                src="https://res.cloudinary.com/devw55qwa/image/upload/v1737435635/WhatsApp_Image_2025-01-17_at_16.34.33_790b4fb8_ucoy6b.jpg"
                alt="Model 1"
                className="object-cover w-full h-full "
              />
            
          </div>
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://res.cloudinary.com/devw55qwa/image/upload/v1737435540/WhatsApp_Image_2025-01-20_at_17.04.09_355ea4ac_gnasn2.jpg"
              alt="Model 2"
              className="object-cover w-full h-full "
            />
          </div>
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://res.cloudinary.com/devw55qwa/image/upload/v1737435634/WhatsApp_Image_2025-01-20_at_16.59.59_c1fcd572_xowp2v.jpg"
              alt="Model 3"
              className="object-cover w-full h-full "
            />
          </div>
        </div>

        {/* About Us Section */}
        <div className="text-center">
          <h2 className="text-2xl font-serif text-gray-800 mb-6 font-bold poppins-medium">ABOUT US</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 font-semibold poppins-light text-gray-700 text-start">
            <p>
              At Booklore, we’re more than just a blog—we’re a haven for storytellers, readers, and dreamers who believe in the magic of words. <br /> Whether it's a debut author who captivates you or a hidden gem that lingers in your mind, we celebrate stories that dare to be different.

              <br />

              📬 Email us at: <span className='font-bold poppins-medium'>itsbooklore@gmail.com</ span>
              <br />
              If you love indie books and believe in their magic, you’re in the right place.
            </p>
            <p>
              🌟 What’s waiting for you?
              <br />
              📖 Behind-the-Scenes – Discover the journey of a book, from concept to creation.
              <br />
              🖋 Creative Challenges – Unleash your imagination with writing contests.
              <br />
              🎉 Exciting Events – Connect with authors and celebrate special days.
              <br />
              🤝 A Supportive Community – Share, inspire, and be inspired.
              <br />
              Got a book to publish? We’d love to hear from you! 📚✨
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-10">
          <a
            href="https://www.booklore.in"
            target="_blank"
            className="text-lg text-black  underline "
          >
            www.booklore.in
          </a>
        </div>
      </div>
    </div>

  );
};

export default AboutPage;


